// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { N30A, N40A, N900 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var wrapperStyle = css({
  display: 'inline-flex',
  width: '100%',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  boxDecorationBreak: 'clone',
  borderRadius: "var(--ds-border-radius, 3px)",
  color: "".concat("var(--ds-text, ".concat(N900, ")")),
  backgroundColor: "".concat("var(--ds-background-neutral, ".concat(N30A, ")")),
  transition: '0.1s all ease-in-out',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: "".concat("var(--ds-background-neutral-hovered, ".concat(N40A, ")"))
  }
});